// @ts-nocheck
import React from "react";
import {StyleProvider} from "./StyleContext";
import {useLocalStorage} from "../hooks/useLocalStorage";

// Centralizes dark/light theme state across routes: persists to localStorage
// (seeded from prefers-color-scheme), exposes {isDark, changeTheme} via
// StyleContext, and applies the top-level `dark-mode` class.
const ThemeProvider = ({children}) => {
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const [isDark, setIsDark] = useLocalStorage("isDark", prefersDark);

  const changeTheme = () => setIsDark(!isDark);

  return (
    <StyleProvider value={{isDark, changeTheme}}>
      <div className={isDark ? "dark-mode" : undefined}>{children}</div>
    </StyleProvider>
  );
};

export default ThemeProvider;
